export var PointType;
(function (PointType) {
    PointType["INTERMEDIATE_POINT"] = "IntermediatePoint";
    PointType["STATION_POINT"] = "StationPoint";
    PointType["BEGINNING_POINT"] = "BeginningPoint";
    PointType["END_POINT"] = "EndPoint";
    PointType["INTERPOLATED_POINT"] = "InterpolatedPoint";
})(PointType || (PointType = {}));
//# sourceMappingURL=types.js.map